<ng-container *ngIf="userBodies && user; else noInfo">

  <div class="title-list">
    <h2>Fotos cuerpo completo del participante: {{ user.name }}</h2>
  </div>
  <div class="container-fluid">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="simple-container">
          <div class="master-container">

            <mat-card style="margin-bottom: 1rem;">
              <mat-card-content>
                <div class="goal-container">
                  <mat-icon svgIcon="targetSvg"></mat-icon> <p class="icon-label">Meta personal:</p>
                  <p>
                    {{ (user && user.goal) ? user.goal : '--' }}
                  </p>
                </div>
              </mat-card-content>
            </mat-card>

            <form [formGroup]="bodyFormArray">
              <ng-container *ngFor="let element of userBodies; let i=index">
                <div class="row">
                  <div class="col-12 col-lg-6 preview-img">
                    <img id="foodImg{{ i }}" src="{{ element.imgURL }}" alt="body img">
                  </div>
                  <div class="col-12 col-lg-6">
                    <ng-container [formGroupName]="i">
                      <div class="body-container">
                        <div class="row">
                          <div class="col-12" *ngIf="element.created_at">
                            <p> <b>Fecha captura:</b> {{ dateConv.transFormDate(element.created_at, 'slash')}} {{ dateConv.transFormDate(element.created_at, 'time')}}</p>
                          </div>
                          <div class="col-12" style="text-align: right;">
                            <button mat-raised-button style="background-color: var(--app-success); color: white;"
                              class="btn btn-principal" (click)="saveComment(bodyFormArray.controls[i])">{{
                                bodyFormArray.controls[i]['controls']['id'].value > 0 ? 'Comentar' :
                              'Guardar'}}</button>
                          </div>
                          <div class="col-12">
                            <mat-form-field appearance="outline" style="color: black; font-size: 18px;">
                              <mat-label>Comentario</mat-label>
                              <textarea matInput rows="3" formControlName="comment">
                                </textarea>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <hr>
              </ng-container>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<ng-template #noInfo>
  <p>No hay información para mostrar</p>
</ng-template>
